/* eslint-disable prettier/prettier */
/*
public function show_Beitragsabrechnung()
    {
                // Bis 31.8.19 soll die Vers. beitragsfrei sein
                if ($this->viergewinnt->offerRequest->contract->beginn <= '2019-08-31') {
                    $this->show_BeitragsabrechnungReplacement();
                    return;
                }
                // Head
                $this->textflow = $this->pdf->add_textflow($this->textflow, "Beitragsabrechnung", $this->boldOptions . " fillcolor=" . $this->colors->rgb->headline);
                $this->dumpThisTextflow(96);
                // Tabelle
                // a: Tabelle aufbauen
                $opts = "rowjoingroup=1 margin=10 matchbox={ borderwidth=0.5 strokecolor={rgb 1 1 1}} ";
                $whiteCellOpts = "rowjoingroup=1 margin=10 matchbox={ borderwidth=0.5 strokecolor={rgb 1 1 1} fillcolor={rgb 1 1 1}} ";
                $table = 0;
                $tableColId = 1;
                $tableRowId = 1;
            $beitragBrutto = $this->viergewinnt->offerRequest->contract->gesamtbeitrag;
                $tableTextflow = $this->pdf->create_textflow("Abrechnung von", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                $tableColId = 2;
                $tableTextflow = $this->pdf->create_textflow("Abrechnung bis", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                // Spalte 3 in erster Zeile ist leer
                $tableColId = 3;
                $tableTextflow = $this->pdf->create_textflow(" ", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                $tableColId = 4;
                $tableTextflow = $this->pdf->create_textflow("zu zahlen zum", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                $tableColId = 5;
                $tableTextflow = $this->pdf->create_textflow("Betrag in Euro", $this->regularOptions . " alignment=right");
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");

                $tableRowId = 2; // Nächste Zeile
                $tableColId = 1;

            $year = (int) substr($this->viergewinnt->offerRequest->contract->beginn, 0, 4);
            $month = (int) substr($this->viergewinnt->offerRequest->contract->beginn, 5, 2);
            $day = (int) substr($this->viergewinnt->offerRequest->contract->beginn, 8, 2);
            $beginnDatum =  sprintf("%02d.%02d.%04d", $day, $month, $year);
            $month += 1;
            $folgeDatum1 = date("d.m.Y", mktime(0, 0, 0, $month, $day, $year));
            $folgeDatum1ForCheck = date("Y-m-d", mktime(0, 0, 0, $month, $day, $year));

            $folgeDatumDT = new DateTime($this->viergewinnt->offerRequest->contract->beginn);
            $folgeDatum2 = $this->monthShifter($folgeDatumDT, 1)->format(('d.m.Y'));
            $folgeDatum2ForCheck = $this->monthShifter($folgeDatumDT, 1)->format(('Y-m-d'));
            if ($folgeDatum1ForCheck < $folgeDatum2ForCheck) {
                $folgeDatum = $folgeDatum1;
            } else {
                $folgeDatum = $folgeDatum2;
            }

                $tableTextflow = $this->pdf->create_textflow($beginnDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 2;
                $tableTextflow = $this->pdf->create_textflow($folgeDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 3;
                $tableTextflow = $this->pdf->create_textflow("Erstbeitrag", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                $tableColId = 4;
                $tableTextflow = $this->pdf->create_textflow($beginnDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 5;
                $tableTextflow = $this->pdf->create_textflow(number_format($beitragBrutto, 2, ',', '.'), $this->regularOptions . " alignment=right");
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");

                $tableRowId = 3;
                $tableColId = 1;
                $tableTextflow = $this->pdf->create_textflow($folgeDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 2;
        $month += 1;    // entspricht: Folge(!)datum plus 1 Monat
        $folgeFolgeDatum1 = date("d.m.Y", mktime(0, 0, 0, $month, $day, $year));
        $folgeFolgeDatum1ForCheck = date("Y-m-d", mktime(0, 0, 0, $month, $day, $year));

        $folgeFolgeDatum2 = $this->monthShifter($folgeDatumDT, 2)->format(('d.m.Y'));
        $folgeFolgeDatum2ForCheck = $this->monthShifter($folgeDatumDT, 2)->format(('Y-m-d'));
        if ($folgeFolgeDatum1ForCheck < $folgeFolgeDatum2ForCheck) {
            $folgeFolgeDatum = $folgeFolgeDatum1;
        } else {
            $folgeFolgeDatum = $folgeFolgeDatum2;
        }
                $tableTextflow = $this->pdf->create_textflow($folgeFolgeDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 3;
                $tableTextflow = $this->pdf->create_textflow("Forderung", $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . " textflow=$tableTextflow");
                $tableColId = 4;
                $tableTextflow = $this->pdf->create_textflow($folgeDatum, $this->regularOptions);
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");
                $tableColId = 5;
                $tableTextflow = $this->pdf->create_textflow(number_format($beitragBrutto, 2, ',', '.'), $this->regularOptions . " alignment=right");
                $table = $this->pdf->add_table_cell($table, $tableColId, $tableRowId, "", $opts . "  textflow=$tableTextflow");

                // b: Tabelle platzieren
                $result = ""; //
                $options = " rowheightdefault=minimum fill={{area=rowodd fillcolor={rgb " . (191 / 255) . " " . (203 / 255) . " " . (233 / 255) . "}} {area=roweven fillcolor={rgb " . (242 / 255) . " " . (244 / 255) . " " . (251 / 255) . "}}}";
                if ($this->pagePosition->y < $this->mm2p(80)) {
                    $this->nextPage();
                }
                do {
                    if ($result == "_boxfull" || $result == "_nextpage") {
                        $this->nextPage();
                    }
                    $result = $this->pdf->fit_table($table, $this->mm2p(190), $this->pagePosition->y, $this->pagePosition->x, $this->mm2p(35), $options);
                    if ($result === '_error') {
                        break;  // Tabelle wird ignoriert
                    }
                } while ($result == "_boxfull" || $result == "_nextpage");
                $this->pagePosition->y -= $this->mm2p(40.7);
                if ($this->pagePosition->y < $this->mm2p(40)) {
                    $this->nextPage();
                }
                // Text unter der Tabelle
                $copy = "Den Gesamtbeitrag von " . number_format(2 * $beitragBrutto, 2, ',', '.') . " Euro werden wir wie vereinbart zum Fälligkeitstermin von dem Konto " . $this->obfuscateIban($this->viergewinnt->offerRequest->policyholder->iban) . " abbuchen. Wir verwenden Ihr Mandat mit der Referenznummer SA0000582430. Gleichzeitig fällige Beträge buchen wir in einer Summe ab.";
                $this->textflow = $this->pdf->add_textflow($this->textflow, $copy, $this->regularOptions . " fillcolor=" . $this->colors->rgb->copy);
                $this->dumpThisTextflow();
    }
*/


const beitragsabrechnungHeader = { text: "\nBeitragsabrechnung\n\n", style: "subHeadOptions" }

const beitragsabrechnungTabelle = {
    style: "tableTextRegular",
    table: {
        widths: [75, 75, 100, 100, 100],   // 5 Spalten und drei Zeilen
        body: [
            ["Abrechnung von", "Abrechnung bis", "", "zu zahlen zum", "Betrag in Euro"],
            ["__beginnDatum__", "__folgeDatum__", "Erstbeitrag", "__beginnDatum__", "__beitragBrutto__"],
            ["__folgeDatum__", "__folgeFolgeDatum__", "Forderung", "__folgeDatum__", "__beitragBrutto__"]
        ]
    }
}
const beitragsabrechnungFooter = [
    { text: "\nDen Gesamtbeitrag von __beitragBrutto__ Euro werden wir wie vereinbart zum Fälligkeitstermin von dem Konto __IBAN__ abbuchen. Wir verwenden Ihr Mandat mit der Referenznummer SA0000582430. Gleichzeitig fällige Beträge buchen wir in einer Summe ab.\n", style: "regularOptions" }
]

export { beitragsabrechnungHeader, beitragsabrechnungTabelle, beitragsabrechnungFooter }